const type = {
  base: `{ font-family: 'Roboto', sans-serif }`,
};

const size = {
  h1: 38,
  h2: 34,
  h3: 30,
  h4: 26,
  h5: 20,
  h6: 19,
  input: 18,
  regular: 17,
  gap: 16,
  medium: 14,
  small: 12,
  tiny: 8.5,
  title: 10,
};

const weight = {
  light: '100',
  regular: '400',
  medium: '500',
  bold: '700',
  black: '900',
};

const style = {
  h1: {
    ...type.base,
    fontSize: size.h1,
    fontWeight: weight.bold,
  },
  h2: {
    ...type.base,
    fontSize: size.h2,
  },
  h3: {
    ...type.base,
    fontSize: size.h3,
  },
  h4: {
    ...type.base,
    fontSize: size.h4,
  },
  h5: {
    ...type.base,
    fontSize: size.h5,
  },
  h6: {
    ...type.base,
    'font-style': 'italic',
    fontSize: size.h6,
  },
  normal: {
    ...type.base,
    fontSize: size.regular,
  },
  description: {
    ...type.base,
    fontSize: size.medium,
    fontWeight: weight.regular,
  },
};

export default {
  type,
  size,
  style,
  weight,
};
